import Api from "../Api";

const basePath = '/call-center';

export default {

    getCustomerVehicleByVin: (vin) => Api.get(`${basePath}/vin/${vin}`),
}
